import { ActionIcon, Loader, LoadingOverlay, Title } from "@mantine/core";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";

import { useSession } from "@/hooks/@custom/useSession";
import { useGetSettingsByCompanyQuery } from "@/store/apis/nextcargo";
import { Stack } from "@mantine/core";

export const Route = createFileRoute("/app/como-chegar/")({
  component: DriverCompanyMap,
  pendingComponent: () => <LoadingOverlay visible overlayProps={{ blur: 3 }} loaderProps={{ children: <Loader type="ring" size="xl" scale="2" /> }} />,
  head: () => ({
    meta: [{ title: "Como Chegar" }]
  })
});

function DriverCompanyMap() {
  const { driver } = useSession();
  const driverCompanyId = driver?.company.id;
  const { data: maps } = useGetSettingsByCompanyQuery(
    { id: driverCompanyId! },
    {
      skip: !driverCompanyId,
      selectFromResult({ data, ...state }) {
        return { data: data?.googleMaps || "", ...state };
      }
    }
  );

  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <div className="maps relative">
      {/* <div className="absolute bottom-12 left-1/2 size-42 -translate-x-1/2 rounded-md bg-white p-2 text-center shadow">
        <p className="leading-none">Bloco para conteúdo adicional aqui</p>
      </div> */}

      <ActionIcon component={Link} to={"/app"} className="absolute! bottom-12 left-1/2 z-10 -translate-x-1/2 shadow" size="xl" color="primary">
        <ArrowLeftIcon weight="bold" />
      </ActionIcon>

      {maps && (
        <iframe className="relative h-[inherit] w-dvw" src={maps} loading="lazy" onLoad={() => setIframeLoaded(true)}>
          <LoadingOverlay visible={!iframeLoaded} loaderProps={{ type: "oval" }} className="absolute!" />
        </iframe>
      )}

      {!maps && (
        <Stack pos="relative" ta="center" className="top-1/2 left-1/2 w-[min(100%,800px)]! -translate-x-1/2 -translate-y-1/2" gap={0}>
          <Title order={1}>Nenhum mapa disponível para esta empresa.</Title>
          <Title order={3} c="gray.5" fw="normal">
            Entre em contato com a empresa para obter informações sobre como chegar.
          </Title>
        </Stack>
      )}
    </div>
  );
}
